import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Button from '@/components/ui/Button';

const NotFoundPage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg-primary px-4">
      <div className="text-center">
        <p className="text-7xl font-bold text-fg-primary">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-[-0.02em] text-fg-primary">
          Страница не найдена
        </h1>
        <p className="mt-3 text-base text-zinc-500">
          Запрашиваемая страница не существует или была перемещена.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/">
            <Button variant="primary" icon={<Home className="h-4 w-4" />}>
              На главную
            </Button>
          </Link>
          <Button
            variant="secondary"
            icon={<ArrowLeft className="h-4 w-4" />}
            onClick={() => window.history.back()}
          >
            Назад
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
